<div class="slider">
  <em class="arrow ds-icon ds-icon--arrow-left"
      *ngIf="this.visibleSlides < this.slides.length"
      (click)="navigate(-1)"
      [style.visibility]="this.position > 0 ? 'visible' : 'hidden'">
  </em>
  <div class="slides">
    <ng-container *ngFor="let slide of slides">
      <div class="slide"
           [ngClass]="'width-' + this.width"
           [style.transform]="'translateX(-'+ this.position * 100 +'%)'"
      >
        <ng-container *ngTemplateOutlet="slide.templateRef"></ng-container>
      </div>
    </ng-container>
  </div>
  <em class="arrow ds-icon ds-icon--arrow-right"
      *ngIf="this.visibleSlides < this.slides.length"
      (click)="navigate(1)"
      [style.visibility]="this.slides.length - this.position > visibleSlides ? 'visible' : 'hidden'"
  >
  </em>
</div>
